import type {
  CodeableConcept,
  Practitioner,
  Reference,
  Task,
} from '@medplum/fhirtypes'
import { addBusinessDays, min } from 'date-fns'
import type { Order } from '#src/models/orders/index.ts'
import { TASK_TYPES } from '#src/models/tasks/constants.ts'
import { StandardTask } from '#src/models/tasks/standard/standardTask.ts'
import { Role } from '#src/roles.ts'
import { now } from '#src/utils.ts'

export class ReviewLabResultsTask extends StandardTask {
  static defaultRoles = [Role.PCP, Role.MA]

  constructor({
    order,
    ...rest
  }: Partial<Omit<Task, 'resourceType'>> & {
    order: Order
    owner?: Reference<Practitioner>
  }) {
    super({
      code: ReviewLabResultsTask.code,
      priority: order.urgent ? 'stat' : 'urgent',
      focus: order.reference,
      ...rest,
    })
    this.title = 'Review Lab Results'
    this.description = 'Review lab results'
    this.state = 'todo'
    this.participant = order.participant
    let dueOn = order.urgent
      ? addBusinessDays(now(), 1).toISOString()
      : addBusinessDays(now(), 2).toISOString()
    if (order.dueDate) {
      dueOn = min([dueOn, order.dueDate]).toISOString()
    }
    this.dueOn = dueOn
  }

  static get code(): CodeableConcept {
    return TASK_TYPES.REVIEW_LAB_RESULTS
  }
}
